export const PORTAL_TIME_ZONE = 'America/New_York'
export const PORTAL_TIME_ZONE_LABEL = 'US Eastern Time'

export function useTimeZone() {
  return {
    timeZone: PORTAL_TIME_ZONE,
    label: PORTAL_TIME_ZONE_LABEL,
  }
}

export function getBrowserTimeZone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? null
  } catch {
    return null
  }
}
